import React from 'react';
import {
  ModalActionsStyled,
  ButtonStyled,
} from '@nike/nike-design-system-components';
import { ActionsProps } from '../../types/ActionsProps';

const Actions: React.FC<ActionsProps> = ({closeModal, handleActiveClick}) => {
  return (
    <ModalActionsStyled>
      <ButtonStyled appearance="primary" size="medium" onClick={handleActiveClick} >
        Proceed
      </ButtonStyled>
      <ButtonStyled appearance="secondary" size="medium" onClick={closeModal} >
        Cancel
      </ButtonStyled>
    </ModalActionsStyled>
  );
};

export default Actions;
